import b_ from 'b_';
import React, {PureComponent} from 'react';

import {Gap} from '#blocks/types';
import './Row.styl';

interface RowProps<T = HTMLDivElement> extends React.HTMLProps<T> {
    innerRef?: React.Ref<T>;
    grow?: boolean;
    gap?: Gap;
    column?: boolean;
    valign?: 'center' | 'end';
    halign?: 'center' | 'end';
    alert?: 'primary' | 'warning';
    isWrap?: boolean;
    disabled?: boolean;
    columnGap?: boolean;
}

const b = b_.with('RowSupport');

class Row extends PureComponent<RowProps> {
    public render() {
        const {
            innerRef,
            column = false,
            className,
            gap = false,
            grow = false,
            valign = false,
            disabled = false,
            halign = false,
            alert = false,
            isWrap = false,
            columnGap = false,
            ...props
        } = this.props;

        const rowClassName = [b({
            gap,
            column,
            valign,
            grow,
            disabled,
            halign,
            alert,
            isWrap,
            columnGap,
        }), className]
            .filter(Boolean)
            .join(' ');

        return (
            <div
                {...props}
                className={rowClassName}
                ref={innerRef}/>
        );
    }
}

export default Row;
